import React from 'react';
import { prop } from 'ramda';
import { Button } from 'js/components/common/Button';
import { FeatureIcon } from 'js/components/common/Game/FeatureIcons';
import { I18n } from 'js/components/common/I18n';
import { useDeviceSelector } from 'js/store/hooks';
import { VOLATILITY } from '../../constants';
import { usePortletTranslations } from 'js/components/system/Portlet';
import style from './index.scss';

export default ({ onClose }) => {
    const t = usePortletTranslations();
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return <>
        <h3 className={style.title}>{t('payOutScore.help.title')}</h3>
        <p>{t('payOutScore.help.part1')}</p>
        <div className={style.row}>
            {VOLATILITY.map((label, index) => <div key={index}
                className={style.volatility}>
                <FeatureIcon type={'volatility'} value={label} className={style.icon} />
                <b>{t(`playtech.mobile.system.featured.volatility.${label}.short`)}</b>
            </div>)}
        </div>
        <p><I18n t={t} tKey={'payOutScore.help.part2'} /></p>
        {!isDesktop && <Button onClick={onClose}>{t('payOutScore.help.close')}</Button>}
    </>;
};
